import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, h } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'vnode-renderer',
  props: {
    nodes: {}
  },
  setup(__props: any) {

const props = __props;

const normalizedNodes = computed(() => {
  if (typeof props.nodes === 'string') {
    return h('span', { innerHTML: props.nodes });
  }

  return props.nodes;
});

return (_ctx: any,_cache: any) => {
  return (Array.isArray(normalizedNodes.value))
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(normalizedNodes.value, (node, index) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(node), { key: index }))
      }), 128))
    : (_openBlock(), _createBlock(_resolveDynamicComponent(normalizedNodes.value), { key: 1 }))
}
}

})